// Fire Harpoons! / Ormund Harpooneers site-relative target filter.
// Pure. No React, no Three.js.
//
// ── Codex ──
//   "Deal 1 damage to target minion above or below an ADJACENT WATER
//    SITE and pull it to the caster's location."
//
// "Adjacent" is the Sorcery cardinal sense (the 4 orthogonal neighbours
// of the caster's cell, no diagonals). "Above or below a water site"
// means the minion shares the cell of that water site. Above = the
// surface unit standing on it, below = a submerged/underwater unit in
// the same cell. So the set of LEGAL TARGET CELLS is exactly the
// caster's cardinal neighbours that contain a water site.
//
// This helper precomputes those cells so the runtime can inject them as
// `filter.cells` on the damage_target op. The standard target halo then
// only lights up minions standing on a legal cell (matchesFilter honours
// `cells` against each candidate's live board square).

/**
 * Cardinal-neighbour cells of `casterCell` that contain a water site.
 *
 * @param casterCell  { col, row }. The caster's grid cell
 * @param totalCols / totalRows  grid dimensions
 * @param isWaterSite (col, row) => boolean. True iff the cell holds a water site
 * @returns {{ col, row }[]} legal target cells (may be empty)
 */
export function siteRelativeTargetCells(casterCell, totalCols, totalRows, isWaterSite) {
  if (!casterCell) return [];
  const { col, row } = casterCell;
  const neighbours = [
    { col: col + 1, row },
    { col: col - 1, row },
    { col, row: row + 1 },
    { col, row: row - 1 },
  ];
  return neighbours.filter(
    (c) =>
      c.col >= 0 && c.col < totalCols &&
      c.row >= 0 && c.row < totalRows &&
      isWaterSite(c.col, c.row),
  );
}
